import { ProfileModel } from './profile.model';

/* eslint-disable @typescript-eslint/naming-convention */
export class Survey {
    id: number;
    hotel_id: number;
    request_id: number;
    survey_header_id: number;
    item_id: number;
    title: string;
    description: string;
    profile_id: number;
    profile_name: string;
    room_no: string;
    rate: number;
    type: string;
    rate_date: Date;

    constructor(profile: ProfileModel, title: string, description: string, rate: number, type: string) {
        this.id = 0;
        this.hotel_id = profile.hotel_id;
        this.request_id = 0;
        this.survey_header_id = 0;
        this.item_id = 0;
        this.title = title;
        this.description = description;
        this.profile_id = profile.id;
        this.profile_name = `${profile.first_name} ${profile.last_name}`;
        this.room_no = profile.room_no;
        this.rate = rate;
        this.type = type;
        this.rate_date = new Date();
    }
}
